//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.PostConfigurator.js";
import "../no/Builder.js";
let d=[[[0,"CurrentLayer",1,0]],[[["blockTemplateName","blockAddressName","blockItemType","expression","addressIndex","isOptional","hasNoWordSeparator"],"AddBlockTemplate",{},7,0],[["blockTemplateName"],"DeleteBlockTemplate",{},1,0],[["addressName","formatName","zeroLimitName","forceType","leader","leaderType","trailer","trailerType","maxIsDefine","maxLimit","maxHandeType","minIsDefine","minLimit","minHandeType"],"AddAddress",{},14,0],[["addressName","formatName","zeroLimitName","forceType","leader","leaderType","trailer","trailerType","maxIsDefine","maxLimit","maxHandeType","minIsDefine","minLimit","minHandeType","omit"],"AddAddressWithOmit",{},15,0],[["addressName"],"DeleteAddress",{},1,0],[["blockTemplateName","addressName"],"DeleteBlockAddress",{},2,0],[["blockTemplateName","blockAddressName","blockItemType","expression","addressIndex","isOptional","hasNoWordSeparator"],"AddBlockAddress",{},7,0],[["formatName","isOutputLeaderPlusSign","isOutputLeadingZeros","isOutputDecimalPoint","isOutputTrailingZeros","visibleDigits","visibleDecimals","formatType"],"AddFormat",{},8,0],[["formatName"],"DeleteFormat",{},1,0],[["addressName"],"GetAddressOmit",{R_:{omit:''}},1,0]],[]];
SPLM.SIM.PostConfigurator.DefEditorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.PostConfigurator.DefEditorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.PostConfigurator.DefEditorBuilder.AddressLeaderType = Object.freeze({
    "Literal" : "Literal", "Expression" : "Expression"});

SPLM.SIM.PostConfigurator.DefEditorBuilder.AddressTrailerType = Object.freeze({
    "Literal" : "Literal", "Expression" : "Expression"});

SPLM.SIM.PostConfigurator.DefEditorBuilder.AddressForceType = Object.freeze({
    "On" : "On", "Once" : "Once", "Always" : "Always"});

SPLM.SIM.PostConfigurator.DefEditorBuilder.AddressLimitHandleType = Object.freeze({
    "TruncateValue" : "TruncateValue", "WarnUser" : "WarnUser", "AbortProcess" : "AbortProcess", "Reset" : "Reset"});

SPLM.SIM.PostConfigurator.DefEditorBuilder.BlockItemType = Object.freeze({
    "Literal" : "Literal", "Address" : "Address", "TurboAddress" : "TurboAddress"});

SPLM.SIM.PostConfigurator.DefEditorBuilder.FormatType = Object.freeze({
    "Numeric" : "Numeric", "Text" : "Text"});

export default SPLM;